<template>
  <div id="app">
    <AutoCheck />
  </div>
</template>

<script>
import AutoCheck from "@/components/AutoCheck";
export default {
  name: 'App',
  components: {
    AutoCheck
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
